import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.app;

export const appSelectors = {
  isLoading: createSelector(selector, (state) => state.isLoading),
  showModal: createSelector(selector, (state) => state.showModal),
  modalObject: createSelector(selector, (state) => state.modalObject),
  showNotification: createSelector(selector, (state) => state.showNotification),
  notificationObject: createSelector(
    selector,
    (state) => state.notificationObject,
  ),
  showSidebarSP: createSelector(selector, (state) => state.showSidebarSP),
};
